import { Stack } from '@mui/material'
import { useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { CustomDateField, CustomSelectField, CustomTimeField } from '../../../components/formField'
import {
  TYPE_DATE,
  typeChildWedding,
  typeForGet,
  typeFuneral,
  typeInsurance,
  typeMaternity,
  typeMyWedding,
  typeOffPay,
  typeOffUnPay,
  typeOT,
  typeOTHoliday,
  typeOTWeekend,
  typeOut,
  typeSummer,
  typeWFH,
  typeWomen
} from '../../../constants/submitType'

type FormBodyProps = {
  type: string
}

export const FormBody = ({ type }: FormBodyProps) => {
  const { control } = useFormContext()
  const [typeDate, setTypeDate] = useState<string>('all_day')
  const onchangeTypeOff = (newValue: any) => {
    setTypeDate(newValue)
  }
  switch (type) {
    case typeWFH.value:
    case typeForGet.value:
    case typeOT.value:
    case typeOTWeekend.value:
    case typeOTHoliday.value:
    case typeOut.value:
      return (
        <div>
          <CustomDateField name="dateSubmit" control={control} label="Date Submit" />
          <Stack direction="row" justifyContent="space-between" spacing={2}>
            <CustomTimeField name="timeStart" control={control} label="Thời gian bắt đầu" />
            <CustomTimeField name="timeEnd" control={control} label="Thời gian kết thúc" />
          </Stack>
        </div>
      )

    case typeOffPay.value:
    case typeOffUnPay.value:
    case typeInsurance.value:
      return (
        <div>
          <CustomSelectField
            name="typeDate"
            control={control}
            label="Loại ngày nghỉ"
            options={TYPE_DATE}
            selectedValue={TYPE_DATE[0].value}
            onSelected={onchangeTypeOff}
          />
          <CustomDateField name="startDate" control={control} label="Start Date" />
          {typeDate != 'hafl_day' && (
            <CustomDateField name="endDate" control={control} label="End Date" />
          )}
        </div>
      )

    case typeWomen.value:
    case typeSummer.value:
    case typeMyWedding.value:
    case typeChildWedding.value:
    case typeFuneral.value:
      return (
        <div>
          <CustomDateField name="startDate" control={control} label="Start Date" />
        </div>
      )

    case typeMaternity.value:
      return (
        <div>
          <CustomDateField name="startDate" control={control} label="Start Date" />
          <CustomDateField name="endDate" control={control} label="End Date" />
        </div>
      )
  }
  return <div></div>
}
